import { Route, Routes } from 'react-router';

import SiteComplianceOnboardPage from '../pages/SiteComplianceOnboardPage';
import SiteCompliancePage from '../pages/SiteCompliancePage';
import SiteCheckpointSettingsPage from '../pages/SiteCheckpointSettingsPage';
import SiteSettingsPage from '../pages/SiteSettingsPage';
import SiteEvaluationPage from '../pages/SiteEvaluationPage';
import SiteDetailPage from '../pages/SiteDetailPage';

const SiteComplianceRoutes = () => {
  return (
    <Routes>
      <Route>
        <Route path="" element={<SiteCompliancePage />} />
        <Route path="onboard" element={<SiteComplianceOnboardPage />} />
        <Route path="settings" element={<SiteSettingsPage />} />
        <Route
          path="settings/checkpoints"
          element={<SiteCheckpointSettingsPage />}
        />
        <Route path="evaluations/:evaluationId" element={<SiteEvaluationPage />} />
        <Route path=":siteId" element={<SiteDetailPage />} />
      </Route>
    </Routes>
  );
};

export default SiteComplianceRoutes;
